module.exports = {
	"cognito": {
		"poolId": "us-east-1:f3383568-a45b-4b65-9a93-d8a4dc582c76"
	},
	"lex": {
		"botName": "DHL",
		"initialText": "You can ask me for help ordering flowers. Just type \"order flowers\" or click on the mic and say it.",
		"initialSpeechInstruction": "Say 'Order Flowers' to get started."
	},
	"polly": {
		"voiceId": "Salli"
	},
	"recorder": {
		"preset": "speech_recognition"
	},
	"ui": {
		"parentOrigin": "http://localhost:8080",
		"pageTitle": "Order Flowers Bot",
		"toolbarTitle": "Order Flowers"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.dev.json
// module id = 429
// module chunks = 1